import {Component, EventEmitter, Inject, Input, OnInit, Output} from '@angular/core';
import {UntypedFormControl, UntypedFormGroup} from '@angular/forms';
import {merge} from 'lodash-es';
import {ApiResponse} from "../../../classes/api-response";
import {SnackService} from "../../../services/snack.service";
import {Box} from "../../../model/box";
import {BoxesService} from "../../../services/boxes-service";
import {SimsService} from "../../../services/sims.service";
import {Constants} from "../../../utils/constants";
import {MAT_DIALOG_DATA} from "@angular/material/dialog";
import {Sim} from "../../../model/sim";
import {AssignSimDTO} from 'src/app/model/dto/sim/assign-sim.dto';

@Component({
  selector: 'aw-add-sim-to-box',
  templateUrl: './add-sim-to-box.component.html',
  styleUrls: ['./add-sim-to-box.component.scss']
})
export class AddSimToBoxComponent implements OnInit {

  addSimToBoxForm: UntypedFormGroup;
  @Output() saved = new EventEmitter<void>();
  @Output() canceled = new EventEmitter<void>();
  loadingSims = false;
  saving = false;
  flag = false;
  generalError?: ApiResponse;
  entities = Constants.entities;
  simsStatuses = Constants.simStatuses;

  sims: Sim[] = [];

  _box = new Box();
  selectedSim?: Sim;

  constructor(
    private boxService: BoxesService,
    private snackService: SnackService,
    private simsService: SimsService,
    @Inject(MAT_DIALOG_DATA) public data: Box,
  ) {

    this.addSimToBoxForm = new UntypedFormGroup(
      {

        sim: new UntypedFormControl(
          null,
          []
        ),
      }
    );
  }



  @Input() set box(value: Box) {
    this._box = merge(new Box(), value);
  }

  ngOnInit(): void {
    this.loadingSims = true;

    this.simsService.getAllSims([this.simsStatuses.unassigned]).subscribe(sims => {
      this.sims = sims;
      this.loadingSims = false;
    });
  }


  addSim(): void {
    if (this.selectedSim) {
      this.saving = true;
      const assignSimDTO = new AssignSimDTO(this.selectedSim);
      this.simsService.associateSim(this._box?.id, assignSimDTO)
        .subscribe(
          () => {
            this.saving = false;
            this.snackService.success('Sim associated!');
            this.saved.emit();
          },
          error => {
            this.saving = false;
            this.snackService.error(error.message);
            this.generalError = error;
          });
    }
  }
}
